"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var person_metadata_filter_html_1 = __importDefault(require("@components/filters/custom-filters/person-metadata-filter.html"));
var angular_1 = require("angular");
var lodash_1 = __importDefault(require("lodash"));
(function (angularModule) {
    angularModule.factory('prPersonMetadataFilterDirectiveLinker', [
        '$q',
        '$timeout',
        'pr.personService',
        function ($q, $timeout, personService) {
            var operatorTranslations = {
                in: 'FSFILTERS.IS',
                notIn: 'FSFILTERS.IS_NOT',
                sameAsSubject: 'FSFILTERS.SAME_AS_SUBJECT'
            };
            var SUBJECT_FIELD_PREFIX = 'Subject';
            var Linker = function (_$rootScope, _$fcFilter, _$scope) {
                var _this = this;
                this.$rootScope = _$rootScope;
                this.$fcFilter = _$fcFilter;
                this.$scope = _$scope;
                this.field = this.$scope.displayedFilter.filter.field;
                this.metadataCache = [];
                this.$scope.template = function () {
                    return person_metadata_filter_html_1.default;
                };
                var operatorMenu = lodash_1.default.map(operatorTranslations, function (translateKey, value) {
                    return {
                        value: value,
                        label: _this.$fcFilter('fcTranslate')(translateKey)
                    };
                });
                $timeout(function () {
                    // timeout is needed to wait for the template scope to be defined
                    _this.$templateScope = _this.$scope.$$childHead;
                    angular_1.extend(_this.$templateScope, {
                        operatorMenu: operatorMenu,
                        onSelection: _this.onSelection.bind(_this),
                        updateFilter: _this.updateFilter.bind(_this),
                        getOperands: _this.getOperands.bind(_this),
                        getOperatorLabel: _this.getOperatorLabel.bind(_this),
                        getOperandLabel: _this.getOperandLabel.bind(_this),
                        isOperandDisabled: _this.isOperandDisabled.bind(_this),
                        operator: _this.$scope.displayedFilter.filter.operator
                    });
                });
            };
            Linker.prototype.onSelection = function (value, selected) {
                var existingOperand = this.$scope.displayedFilter.filter.operand || [];
                if (selected) {
                    this.updateFilter(existingOperand.concat([value]));
                }
                else {
                    this.updateFilter(lodash_1.default.without(existingOperand, value));
                }
            };
            Linker.prototype.updateFilter = function (value) {
                this.$scope.displayedFilter.filter.operator = this.$templateScope.operator;
                this.$scope.displayedFilter.filter.operand = this.isOperandDisabled() || value;
                this.$rootScope.$broadcast('filterChanged');
            };
            Linker.prototype.isOperandDisabled = function () {
                return this.$templateScope.operator === 'sameAsSubject';
            };
            Linker.prototype.getOperatorLabel = function () {
                return operatorTranslations[this.$templateScope.operator];
            };
            Linker.prototype.getOperandLabel = function () {
                var operand = this.$scope.displayedFilter.filter.operand;
                if (!operand || !operand.length) {
                    return this.$fcFilter('fcTranslate')('FSFILTERS.SELECT_OPERAND');
                }
                else if (operand.length > 1) {
                    return operand.length + ' ' + this.$fcFilter('fcTranslate')('FSFILTERS.SELECTED');
                }
                return operand[0];
            };
            Linker.prototype.getOperands = function (search) {
                var _this = this;
                var operand = this.$scope.displayedFilter.filter.operand;
                return this.getMetadataCache()
                    .then(function () {
                    if (!_this.metadataCache.length) {
                        return [{
                                label: _this.$fcFilter('fcTranslate')('FSFILTERS.NO_AVAILABLE_FIELDS'),
                                disabled: true
                            }];
                    }
                    var header = [{
                            header: true,
                            label: _this.$fcFilter('fcTranslate')('FSFILTERS.SELECT_ONE_OR_MORE_FIELDS')
                        }, {
                            divider: true
                        }];
                    var menuItems = _this.metadataCache.map(function (value) {
                        if (search && search.length > 1) {
                            // Do not generate a menu item if the field does not inclue the search term
                            if (!lodash_1.default.includes(lodash_1.default.toLower(value), lodash_1.default.toLower(search))) {
                                return;
                            }
                        }
                        return {
                            value: value,
                            label: value,
                            selected: lodash_1.default.includes(operand, value)
                        };
                    });
                    return header.concat(lodash_1.default.compact(menuItems));
                });
            };
            Linker.prototype.getMetadataCache = function () {
                var _this = this;
                if (!lodash_1.default.isEmpty(this.metadataCache)) {
                    return $q.when(this.metadataCache);
                }
                var requestField = this.field;
                // Subject fields have a prefix on the fieldset; remove the fieldset to request values
                if (lodash_1.default.startsWith(this.field, SUBJECT_FIELD_PREFIX) && this.field.length > SUBJECT_FIELD_PREFIX.length) {
                    requestField = requestField.slice(SUBJECT_FIELD_PREFIX.length);
                }
                return personService.getMetadataValues(requestField)
                    .then(function (metadataValues) {
                    _this.metadataCache = metadataValues;
                });
            };
            return Linker;
        }
    ]);
})(angular_1.module('qualtrics.pr'));
